module.exports = __webpack_public_path__ + "static/media/block_icon_text.64487eac.svg";